<template>
    <site-img
        v-if="filteredList.length > 0"
        class="md-quick-search layout1 mg-bg"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgType == 'color' ? bgColor : null
        }"
        dir="width"
    >
        <div :fullColumn="fullColumn" class="quick-search-inner f-col">
            <site-title
                class="quick-search-title"
                v-if="selectedQuickSearch.title"
                :title="selectedQuickSearch.title"
                :align="align"
            />
            <div class="list" v-if="filteredList.length > 0">
                <ul :class="{ 'quick-list': true, collapse: collapse, 'pc-collapse': collapse && !isMobileSize}">
                    <li
                        v-for="item in filteredList"
                        :key="item.id"
                        class="quick-search-item"
                        :class="{ hot: item.hot }"
                    >
                        <a
                            v-if="item.type != 'link'"
                            :href="item.href"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span v-if="item.hot" class="hot-search">
                                <i class="iconfont icon-hot"></i>
                            </span>
                            <Count
                                :max="mlsCount"
                                :count="
                                    countMap[item.key] === undefined
                                        ? -1
                                        : countMap[item.key]
                                "
                            />
                        </a>
                        <a
                            v-else
                            :href="item.url"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span v-if="item.hot" class="hot-search">
                                <i class="iconfont icon-hot"></i>
                            </span>
                        </a>
                    </li>
                </ul>
                <div
                    v-if="showmore"
                    class="quicksearch-more"
                    @click="toggleShowMore"
                >
                    <span v-if="isMobileSize">
                        {{
                            $t('md-quick-search.thereAreQuickSearches', {
                                count: filteredList.length
                            })
                        }}
                    </span>
                    <span v-else>{{ btnText }}</span>
                </div>
            </div>
        </div>
        <div
            class="img-mask"
            v-if="bgType == 'img' && maskOption.showMask"
            :style="{
                backgroundColor: maskOption.maskColor
            }"
        ></div>
    </site-img>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    data() {
        return {};
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-quick-search.layout1 {
    .quick-search-inner {
        position: relative;
        z-index: 20;
    }
    .quick-search-title {
        margin-bottom: 40px;
    }
    .list {
        .quick-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            column-gap: 40px;
            row-gap: 20px;
            li {
                width: calc((100% - 80px) / 3);
                font-size: 14px;
                font-weight: 500;
                line-height: 21px;
                a {
                    width: 100%;
                    display: flex;
                    flex-wrap: nowrap;
                    .search-title {
                        font-size: 14px;
                        line-height: 21px;
                        text-align: left;
                        color: var(--g-text-color);
                        font-weight: 500;
                        @include ellipsis();
                    }
                    .hot-search {
                        padding-left: 10px;
                        font-size: 18px;
                        text-align: left;
                        color: rgba(240, 69, 76, 1);
                        line-height: 21px;
                    }
                    .num {
                        font-size: 14px;
                        flex: 1;
                        padding-left: 8px;
                        text-align: right;
                        color: var(--g-text-color);
                        line-height: 21px;
                        font-weight: 500;
                    }
                    &:hover {
                        .search-title {
                            text-decoration: underline;
                        }
                    }
                }
            }
            &.pc-collapse {
                overflow: hidden;
                li {
                    display: none;
                    &:nth-child(-n + 15) {
                        display: block;
                    }
                }
            }
        }
        .quicksearch-more {
            margin-top: 40px;
            display: block;
            font-size: 14px;
            line-height: 24px;
            font-weight: 400;
            color: var(--g-text-color);
            text-decoration: underline;
            text-align: center;
            cursor: pointer;
        }
    }
    .img-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        pointer-events: none;
    }

    @include media-800 {
        .quick-search-title {
            margin-bottom: 20px;
        }
        .list {
            .quick-list {
                li {
                    width: 100%;
                    display: block;
                }
                &.collapse {
                    overflow: hidden;
                    li {
                        display: none;
                        &:nth-child(-n + 5) {
                            display: block;
                        }
                    }
                }
            }
            .quicksearch-more {
                margin-top: 20px;
            }
        }
    }
}
</style>
